import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=2bb39d65&scoped=true&"
import script from "./DocumentRow.vue?vue&type=script&lang=ts&"
export * from "./DocumentRow.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentRow.vue?vue&type=style&index=0&id=2bb39d65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb39d65",
  null
  
)

export default component.exports